type BuildAttachmentPreviewUrlParams = {
  shipmentId: number
  visitId: number
  attachmentId: number
  name: string
}

/**
 * 納品実績詳細の添付ファイル確認用ページ（別タブ）への URL を組み立てる純粋関数。
 * ファイル名は表示・拡張子判定用に query で渡す。
 * ルート定義（`containers/AppPrivate/index.js`）と同じパス構造を保つこと。
 */
export const buildAttachmentPreviewUrl = ({
  shipmentId,
  visitId,
  attachmentId,
  name,
}: BuildAttachmentPreviewUrlParams): string =>
  `/delivery-performances/${shipmentId}/visits/${visitId}/delivery-work/attachments/${attachmentId}?name=${encodeURIComponent(
    name
  )}`
